var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectionMCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 127,
    viewBox: "0 0 127 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: -11.52,
    cy: 59.48,
    r: 59.48,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: -11.5214,
    cy: 59.4801,
    r: 52.045,
    fill: "#FFFFF6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: -11.5189,
    cy: 59.4801,
    r: 44.61,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: -11.5203,
    cy: 59.4802,
    r: 37.175,
    fill: "#FFFFF6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: -11.5217,
    cy: 59.4797,
    r: 29.74,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: -11.5192,
    cy: 59.4798,
    r: 22.305,
    fill: "#FFFFF6"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.675,
    cy: 85.675,
    r: 40.675,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.6766,
    cy: 85.6751,
    r: 35.5906,
    fill: "#FFFFF6"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.6742,
    cy: 85.6752,
    r: 30.5062,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.6758,
    cy: 85.6748,
    r: 25.4219,
    fill: "#FFFFF6"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.6734,
    cy: 85.6749,
    r: 20.3375,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.675,
    cy: 85.675,
    r: 15.2531,
    fill: "#FFFFF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectionMCircle);
export default __webpack_public_path__ + "static/media/collectionMCircle.709da0df1125b4440c708e178fc8daa5.svg";
export { ForwardRef as ReactComponent };